export class ArgumentException extends Error {}
